/* eslint-env es2020 */
const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function base62ToUuid(shortId) {
  if (!shortId) return null;
  let n = BigInt(0);
  for (let i = 0; i < shortId.length; i += 1) {
    const idx = ALPHABET.indexOf(shortId[i]);
    if (idx < 0) return null;
    n = n * BigInt(62) + BigInt(idx);
  }
  const hex = n.toString(16).padStart(32, "0");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
    16,
    20
  )}-${hex.slice(20)}`;
}
